import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isPublicError, PublicError } from '@dimandzhi/graphql';
import JSONFormatter from 'json-formatter-js';

export type ErrorDialogInput = PublicError | Object | ArrayLike<any>;

@Component({
  selector: 'error-dialog',
  templateUrl: 'error-dialog.html',
  styleUrls: ['error-dialog.scss'],
  //standalone: true,
  //imports: [MatDialogModule, NgIf],
})
export class ErrorDialog implements AfterViewInit {
  @ViewChild('causeDisplay') causeDisplay: ElementRef<HTMLDivElement>;
  declare isPublicError;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorDialogInput) {
    this.isPublicError = isPublicError(this.data);
  }

  asPublicError() {
    return this.data as PublicError;
  }

  ngAfterViewInit(): void {
    if (this.isPublicError) {
      const pubErr = this.asPublicError();
      const formatter = new JSONFormatter(JSON.parse(JSON.stringify(pubErr.cause)));
      this.causeDisplay.nativeElement.appendChild(formatter.render());
      formatter.openAtDepth(3);
      return;
    }
    const formatter = new JSONFormatter(JSON.parse(JSON.stringify(this.data)));
    this.causeDisplay.nativeElement.appendChild(formatter.render());
    formatter.openAtDepth(3);
  }
}
